<template>
  <CChartLine
    :datasets="chartData.datasets"
    :labels="chartData.labels"
    :options="chartOptions"
  />
</template>

<script>
import { CChartLine } from '@coreui/vue-chartjs'
import { formatMyr } from '@/utils/money'

export default {
  name: 'ReceiptTrendChart',
  components: { CChartLine },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              usePointStyle: true,
              padding: 20
            }
          },
          tooltip: {
            callbacks: {
              title: function(context) {
                return `${context[0].label} receipts`;
              },
              label: function(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  
                  label += `RM ${formatMyr(context.parsed.y)}`;
                }
                return label;
              },
              afterLabel: function(context) {
                if (context.datasetIndex === 0) {
                  return `Count: ${context.raw} receipts`;
                }
                return '';
              }
            }
          }
        },
        scales: {
          x: {
            grid: {
              drawOnChartArea: false,
              color: '#e3e6f0'
            },
            ticks: {
              color: '#6c757d',
              font: {
                size: 12
              }
            }
          },
          y: {
            beginAtZero: true,
            grid: {
              color: '#e3e6f0'
            },
            ticks: {
              color: '#6c757d',
              font: {
                size: 12
              },
              callback: function(value) {
                
                return `RM ${formatMyr(value)}`;
              }
            }
          }
        },
        elements: {
          point: {
            radius: 4,
            hoverRadius: 6,
            borderWidth: 2
          },
          line: {
            tension: 0.4,
            borderWidth: 3
          }
        },
        interaction: {
          intersect: false,
          mode: 'index'
        }
      }
    }
  }
}
</script>